import { enqueueSnackbar } from 'notistack';

import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------
// TESTING/STAGING ONLY — surfaces the tokenised signer link in the UI so the
// flow can be exercised without relying on email delivery. Remove this component
// (and its usages) before production.
// ----------------------------------------------------------------------

export function buildSignerLink(token: string) {
  return `${window.location.origin}/signing/sign/${token}`;
}

interface Props {
  token: string;
  name?: string;
  showUrl?: boolean;
}

export default function CopySignerLink({ token, name, showUrl = true }: Props) {
  const url = buildSignerLink(token);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      enqueueSnackbar('Signing link copied', { variant: 'success' });
    } catch {
      enqueueSnackbar('Could not copy link', { variant: 'error' });
    }
  };

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      {name && (
        <Typography variant="caption" sx={{ flexShrink: 0, fontWeight: 600 }}>
          {name}
        </Typography>
      )}
      {showUrl && (
        <Typography variant="caption" color="text.secondary" sx={{ wordBreak: 'break-all', flexGrow: 1 }}>
          {url}
        </Typography>
      )}
      <Tooltip title="Copy signing link">
        <IconButton size="small" onClick={handleCopy}>
          <Iconify icon="solar:copy-bold" width={16} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
